import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpService from "../services/HttpServices";

const apiService = HttpService;

// Initial state of the slice
const initialState = {
  actualProcessLossList: [],
  loading: false,
  error: null,
  processLossPageInfo: {},
  definedProcessLossInfo: "",
  definedProcessLossData: "",
};

// Async thunk for fetching actual process loss for the table
export const fetchActualProcessLoss = createAsyncThunk(
  "processLoss/fetchActualProcessLoss",
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get("/process-loss", {
        params: queryParams,
      });
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for fetching defined process loss for the view
export const fetchDefinedProcessLoss = createAsyncThunk(
  "processLoss/fetchDefinedProcessLoss",
  async (queryParams, thunkAPI) => {
    try {
      console.log("Calling!", queryParams);
      const response = await apiService.get("/process-loss", {
        params: queryParams,
      });
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for editing process loss values
export const editProcessLoss = createAsyncThunk(
  'processLoss/editProcessLoss',
  async (definedProcessLossData, { rejectWithValue }) => {
    try {
      const response = await apiService.patch('/process-loss', {data:definedProcessLossData});
      return response.data; // Assuming the API responds with the edited process loss
    } catch (error) {
      return rejectWithValue(error.response.data); // Handling API errors
    }
  }
);

// The Process Loss slice
export const processLossSlice = createSlice({
  name: "processLoss",
  initialState,
  reducers: {
    resetProcessLossState: (state) => {
      state.actualProcessLossList = [];
      state.loading = false;
      state.error = null;
      state.processLossPageInfo = {};
      state.definedProcessLossInfo = "";
      state.definedProcessLossData = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Handling fetch Actual Process Loss List
      .addCase(fetchActualProcessLoss.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActualProcessLoss.fulfilled, (state, action) => {
        state.loading = false;
        state.actualProcessLossList = action.payload.data;
        state.processLossPageInfo = {
          totalRecords: action.payload.totalRecords,
        };
      })
      .addCase(fetchActualProcessLoss.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handling fetch Defined Process Loss Info
      .addCase(fetchDefinedProcessLoss.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDefinedProcessLoss.fulfilled, (state, action) => {
        state.loading = false;
        state.definedProcessLossInfo = action.payload.data;
      })
      .addCase(fetchDefinedProcessLoss.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handling edit Defined Process Loss Info
      .addCase(editProcessLoss.pending, (state) => {
        state.loading = true;
      })
      .addCase(editProcessLoss.fulfilled, (state, action) => {
        state.loading = false;
        state.definedProcessLossInfo = action.payload.data;
      })
      .addCase(editProcessLoss.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { resetProcessLossState } = processLossSlice.actions;
export default processLossSlice.reducer;
